{
  "datasets": {
    "title": "Datasets",
    "table": {
      "labels": {
        "id": "ID",
        "name": "Name",
        "description": "Description",
        "raw_size": "Raw size",
        "identifier": "Identifier",
        "category": "Category",
        "categoryId": "Category id",
        "schema": "Schema",
        "database": "Database",
        "import_size": "Import size",
        "final_size": "Final size",
        "created_at": "Created at",
        "updated_at": "Updated at",
        "visible": "Visible",
        "exists": "Exists",
        "edit": "Edit",
        "delete": "Delete",
        "verify_all": "Verify datasets",
        "verify": "Verify",
        "add": "Add dataset",
        "yes": "Yes",
        "no": "No",
        "invisible": "Invisible",
        "not_exist": "Non-existent",
        "not_deletable": "The Dataset is already being used and can not be deleted",
        "imports": "Imports"
      },
      "show_more": "Show more"
    },
    "form": {
      "edit_title": "Edit dataset",
      "add_title": "Add dataset",
      "add": "Add",
      "save": "Save",
      "name": "Name",
      "description": "Description",
      "database": "Database",
      "schema": "Schema",
      "rawSizeMb": "Raw size (MB)",
      "finalSizeMb": "Final size (MB)",
      "importSizeMb": "Import size (MB)",
      "categoryId": "Category",
      "visible": "Visible",
      "identifier": "Identifier",
      "errors": {
        "identifier": {
          "duplicate_identifier": "A dataset with this identifier already exists",
          "no_spaces": "The identifier may not contain spaces",
          "required": "Identifier field is required"
        },
        "database": {
          "required": "Database field is required"
        },
        "schema": {
          "required": "Schema field is required"
        },
        "name": {
          "required": "Name field is required"
        },
        "rawSizeMb": {
          "required": "Raw size field is required",
          "number": "Raw size should be a number"
        },
        "finalSizeMb": {
          "required": "Final size field is required",
          "number": "Final size should be a number"
        },
        "importSizeMb": {
          "required": "Import size field is required",
          "number": "Import size should be a number"
        },
        "categoryId": {
          "required": "Category is required"
        },
        "description": {
          "required": "Description field is required"
        }
      }
    },
    "confirmations": {
      "delete_dataset": "Do you really want to delete the dataset {{name}}?"
    },
    "categories": {
      "title": "Datasets categories",
      "table": {
        "labels": {
          "thumbnail": "Thumbnail",
          "name": "Name ({{currentLanguage}})",
          "created_at": "Created at",
          "updated_at": "Updated at",
          "edit": "Edit",
          "delete": "Delete",
          "delete_disabled": "This category is being used {{count}} time and may not be deleted",
          "delete_disabled_plural": "This category is being used {{count}} times and may not be deleted",
          "identifier": "Identifier",
          "add_category": "Add new category",
          "datasets": "Datasets"
        },
        "show_more": "Show more"
      },
      "form": {
        "add_title": "Add new category",
        "edit_title": "Edit category",
        "add": "Add",
        "save": "Save",
        "name": "Name ({{currentLanguage}})",
        "identifier": "Identifier",
        "upload_thumbnail": "Upload thumbnail",
        "warnings": {
          "identifier": "Changing the \"Identifier\" might break some automation that relies on this particular value"
        },
        "errors": {
          "name": {
            "required": "Name ({{i18n}}) field is required"
          },
          "thumbnail": {
            "required": "Thumbnail field is required"
          },
          "identifier": {
            "no_spaces": "Identifier field must not contain spaces",
            "duplicate_identifier": "A category with this identifier already exists",
            "required": "Identifier field is required"
          }
        }
      },
      "confirmations": {
        "delete_category": "Do you really want to delete {{name}} category?"
      }
    }
  },
  "navigation": {
    "users": "Users",
    "enquiries": "Tickets",
    "datasets": "Datasets",
    "datasets_categories": "Categories",
    "system-config": "Settings",
    "general": "General",
    "email": "Email",
    "support_configuration": "Support",
    "imprint": "Imprint",
    "send-email": "Email test",
    "organizations": "Organizations",
    "orphans": "Orphaned clusters",
    "manage_plans": "Plans",
    "compute_plans": "Compute plans",
    "storage_plans": "Storage plans",
    "support_plans": "Support plans",
    "help": "Help",
    "help_subjects": "Subjects",
    "help_articles": "Articles"
  },
  "clusters": {
    "orphans_title": "Orphans",
    "table": {
      "labels": {
        "namespace": "namespace",
        "status": "status",
        "whitelisted": "whitelisted"
      },
      "actions": {
        "add_to_whitelist": "Add to whitelist",
        "remove_from_whitelist": "Remove from whitelist",
        "delete_cluster": "Delete cluster"
      }
    },
    "modals": {
      "confirm_deleting": "Are you sure that you want to delete this cluster? This cannot be undone.",
      "confirm_adding_to_whitelist": "Are you sure that you want to whitelist this cluster?",
      "confirm_removing_from_whitelist": "Are you sure that you want to remove this cluster from the whitelist?",
      "success_deleting": "Cluster was deleted",
      "success_adding": "Cluster was added to the whitelist",
      "success_removing": "Cluster was removed from the whitelist"
    }
  },
  "system_configuration": {
    "title": "General Configuration",
    "form": {
      "allow_service_creation": "Allow service creation",
      "show_cost": "Display costs",
      "show_instance_cost": "Instance costs",
      "show_support_cost": "Support costs ",
      "min_cpu_value": "Min. number of CPUs for Cluster",
      "max_cpu_value": "Max. number of CPUs for Cluster",
      "min_memory_value": "Min. Gbs of Memory for Cluster",
      "max_memory_value": "Max. Gbs of Memory for Cluster",
      "min_storage_value": "Min. Gbs of Storage for Cluster",
      "max_storage_value": "Max. Gbs of Storage for Cluster",
      "min_replicas_value": "Min. Replicas of Cluster",
      "max_replicas_value": "Max. Replicas of Cluster",
      "currency": "Currency code",
      "cpu_price_per_month": "Price per CPU unit per month (720h)",
      "memory_price_per_month": "Price per memory GB per month (720h)",
      "storage_price_per_month": "Price per storage GB per month (720h)",
      "cpu_request_to_limit_multiplier": "Multiplier for CPU Limit in relation to CPU Request (increase to allow \"bursting\")",
      "placeholder": "Leave empty for unlimited",
      "currency_tooltip": "The three-letter currency code (e.g., USD, EUR) used to display prices. This only changes the symbol and does not affect conversion rates or actual pricing",
      "instance_cost_tooltip": "Shows the resources cost of the service  (CPU, memory, storage)",
      "support_cost_tooltip": "Shows the costs for the chosen support plan for the service "
    },
    "support": {
      "title": "Support Configuration",
      "subtitles": {
        "authentication": "Authentication",
        "serviceDesk": "Service Desk"
      },
      "form": {
        "atlassianUrl": "Atlassian URL",
        "atlassianUrlExplanation": "Atlassian URL: The base URL to be used during API requests",
        "atlassianUrlPlaceholder": "https://cybertec.atlassian.net",
        "email": "Email",
        "emailExplanation": "Email: The address of the Jira user will interact with the Jira Service Desk",
        "emailPlaceholder": "bot@cybertec.at",
        "serviceDeskKey": "Service Desk Key",
        "serviceDeskKeyExplanation": "Service Desk Key: The short-key of the service desk (i.e. CSD, RDBA, etc.)",
        "serviceDeskKeyPlaceholder": "RDBA",
        "token": "Token",
        "tokenPart1": "Token: A ",
        "tokenPart2": "Jira API token",
        "tokenPart3": " that may be used with the provided account",
        "tokenLink": "https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/",
        "tokenPlaceholder": "BACSK5jMqGF0..."
      }
    },
    "change_saved": "Changes saved",
    "change_saved_redirect": "Changes saved. You can test the SMTP settings on the <0>test email page</0>",
    "redirect_page": "Redirect to email test",
    "config_ok": "Successfully connected to Jira API.",
    "config_error": "Could not connect to Jira API with the provided credentials"
  },
  "email_configuration": {
    "title": "Email Configuration",
    "group_titles": {
      "system_notifications": "System notifications"
    },
    "password": {
      "show": "Show password",
      "hide": "Hide password"
    },
    "token": {
      "show": "Show token",
      "hide": "Hide token",
      "tooltip": "Use a token generated in 'App Passwords' in your Google account"
    },
    "form": {
      "hostname": "Hostname",
      "port": "Port",
      "username": "Username",
      "password": "Password",
      "secure": "Secure",
      "type": "Type",
      "enquiryEmails": "Enquiry email",
      "email_hint": "Recipients - separate multiple addresses by comma (e.g. email@gmail.com,email@gmail.com)",
      "notification_language": "Notification language",
      "sender_email": "Sender email",
      "sender_email_hint": "(leave empty to use SMTP username)",
      "email_address": "Email address",
      "email_token": "Email token"
    }
  },
  "imprint_configuration": {
    "title": "Imprint configuration",
    "form": {
      "imprint": "Imprint",
      "imprint_tooltip": "Use valid HTML code"
    }
  },
  "email_test": {
    "title": "Email Test",
    "email": "Email",
    "subject": "Subject",
    "html": "Html",
    "success-modal": "Your email was sent"
  },
  "buttons": {
    "submit": "Submit",
    "test-connection": "Test connection",
    "ok": "OK"
  },
  "users": {
    "title": "Users",
    "table": {
      "labels": {
        "name": "Name",
        "email": "Email",
        "superuser": "Superuser",
        "activated": "Activated",
        "verified": "Verified",
        "show_more": "Show more"
      },
      "actions": {
        "forgot_passwd": "Restore password",
        "deactivate": "Deactivate",
        "reactivate": "Reactivate",
        "add_superuser_rights": "Add superuser privileges",
        "remove_superuser_rights": "Remove superuser privileges"
      },
      "hints": {
        "you": "You",
        "forbidden_deactivate_yourself": "You cannot deactivate your account"
      }
    },
    "description_panel": {
      "labels": {
        "country": "Country",
        "city": "City",
        "state": "State",
        "address": "Address",
        "postal_code": "Postal code",
        "phone": "Phone",
        "email": "Email"
      },
      "yes": "Yes",
      "no": "No"
    },
    "confirmations": {
      "deactivate": "Deactivating a user will close all of their sessions and prevent them from logging in. Are you sure that you want to deactivate {{user}}?",
      "reactivate": "Are you sure you want to reactivate {{user}}?",
      "deactivate_superuser": "Are you sure that you want to remove a superuser privileges for {{user}}?",
      "reactivate_superuser": "Are you sure you want to add a superuser privileges for {{user}}?",
      "forgot_passwd": "Are you sure that you want to trigger the Forgot Password process for {{email}} ({{userName}})?"
    },
    "errors": {
      "forgot_passwd": {
        "unprocessable_entity": "The provided email does not exist"
      },
      "user": {
        "no_superusers_left": "You cannot deactivate your account since you are the last user with active one."
      },
      "superuser_rights": {
        "no_superusers_left": "You may not revoke your superuser privileges since you are the last superuser."
      }
    },
    "success": {
      "forgot_passwd": "The user {{email}} ({{userName}}) should have received an email containing further instructions on how to reset their password"
    }
  },
  "manage_plans": {
    "dialogs": {
      "titles": {
        "storage_plan": {
          "create": "Create storage plan",
          "update": "Update storage plan"
        },
        "compute_plan": {
          "create": "Create compute plan",
          "update": "Update compute plan"
        },
        "support_plan": {
          "create": "Create a support plan",
          "update": "Update a support plan"
        }
      },
      "actions": {
        "add": "Create plan",
        "edit": "Edit plan",
        "delete": "Delete plan"
      },
      "confirmation": {
        "delete_plan": "Are you sure you want to delete \"{{planName}}\" plan?"
      },
      "labels": {
        "id": "ID",
        "name": "Name",
        "description": "Description",
        "price": "Price",
        "size": "Size [GB]",
        "service": "Service",
        "storage_class": "Storage Class",
        "is_visible": "Visible",
        "is_default": "Default",
        "cpu": "Cores",
        "memory": "Memory [GB]",
        "replica_min": "Min Replica",
        "replica_max": "Max Replica",
        "replica_default": "Default Replica"
      },
      "errors": {
        "product_already_has_default_plan": "This product already has a default plan",
        "replica_default_outside_of_boundaries": "Replica Default is outside of the min and max values",
        "support_plan_duplicate_name": "A support plan with this name already exists"
      },
      "buttons": {
        "submit": "Save",
        "cancel": "Cancel"
      }
    },
    "storage_plans": {
      "title": "Storage Plans"
    },
    "compute_plans": {
      "title": "Compute Plans"
    },
    "support_plans": {
      "title": "Support Plans"
    },
    "disabled_reasons": {
      "plan_already_in_use": "Can't delete as this plan is already in use",
      "plan_is_default": "Can't delete as this plan is default"
    }
  },
  "material_table": {
    "body": {
      "emptyDataSourceMessage": "Nothing was found",
      "addTooltip": "Add",
      "deleteTooltip": "Delete",
      "editTooltip": "Edit",
      "filterRow": {
        "filterTooltip": "Filter"
      },
      "editRow": {
        "deleteText": "Do you want to remove this row?",
        "cancelTooltip": "Cancel",
        "saveTooltip": "Save"
      }
    },
    "grouping": {
      "placeholder": "Drag columns ...",
      "groupedBy": "Group by:"
    },
    "header": {
      "actions": "Actions"
    },
    "pagination": {
      "labelDisplayedRows": "{from}-{to} of {count}",
      "labelRowsSelect": "rows",
      "labelRowsPerPage": "Rows per page:",
      "firstAriaLabel": "First page",
      "firstTooltip": "First page",
      "previousAriaLabel": "Previous page",
      "previousTooltip": "Previous page",
      "nextAriaLabel": "Next page",
      "nextTooltip": "Next page",
      "lastAriaLabel": "Last page",
      "lastTooltip": "Last page"
    },
    "toolbar": {
      "addRemoveColumns": "Add or remove columns",
      "nRowsSelected": "{0} row(s) selected",
      "showColumnsTitle": "Show columns",
      "showColumnsAriaLabel": "Show columns",
      "exportTitle": "Export",
      "exportAriaLabel": "Export",
      "exportName": "Export as CSV",
      "searchTooltip": "Search",
      "searchPlaceholder": "Search"
    }
  },
  "organizations": {
    "title": "Organizations",
    "table": {
      "label": {
        "name": "Name",
        "description": "Description",
        "email": "Email",
        "verified": "Verified",
        "show_more": "Show more",
        "info": "Info",
        "company_name": "Company Name",
        "language": "Language"
      }
    },
    "description_panel": {
      "details": {
        "name": "Name",
        "company_name": "Company Name",
        "description": "Description",
        "email": "Email",
        "vat_number": "Vat Number",
        "verified": "Verified",
        "language": "Language"
      },
      "address": {
        "line1": "Line1",
        "line2": "Line2",
        "line3": "Line3",
        "postal_code": "Postal Code",
        "city": "City",
        "state": "State",
        "country": {
          "code": "Code",
          "name": "Name",
          "calling_code": "Calling Code"
        }
      },
      "yes": "Yes",
      "no": "No"
    },
    "info_list": {
      "fields": {
        "projects": "Projects",
        "users": "Users",
        "teams": "Teams",
        "invitations": "Invitation",
        "registration_invitations": "Registration Invitation"
      },
      "user": {
        "first_name": "First Name",
        "middle_name": "Middle Name",
        "last_name": "Last Name",
        "email_address": "Email Address",
        "role": "Role",
        "verified": "Verified",
        "marketable": "Receive Marketing",
        "phone_number": "Phone"
      }
    },
    "empty_section": "This section is empty"
  },
  "postgres_version": {
    "label": "PostgreSQL version",
    "postgresql": "PostgreSQL"
  },
  "help": {
    "subjects": {
      "table": {
        "title": "Subjects",
        "labels": {
          "subject_title": "Title",
          "updated_at": "Updated at",
          "articles": "Articles",
          "show_more": "Show more"
        },
        "actions": {
          "edit": "Edit subject",
          "delete": "Delete subject",
          "add": "Create subject"
        },
        "disabled_reasons": {
          "subject_has_articles": "Can't delete because subject has articles"
        },
        "confirmation": {
          "delete_subject": "Are you sure you want to delete \"{{subject}}\" subject?"
        }
      },
      "details_panel": {
        "title": "Title ({{lang}})",
        "created_at": "Created At",
        "updated_at": "Updated At",
        "articles": "Articles"
      },
      "subject_form": {
        "edit_title": "Edit Subject",
        "create_title": "Create Subject",
        "submit": "Submit",
        "cancel": "Cancel",
        "form": {
          "name": "Title ({{lang}})"
        }
      }
    },
    "articles": {
      "table": {
        "title": "Articles",
        "labels": {
          "subjects": "Subjects",
          "article_title": "Title",
          "short_content": "Short content",
          "updated_at": "Updated at",
          "show_more": "Show more"
        },
        "actions": {
          "edit": "Edit article",
          "delete": "Delete article",
          "add": "Create article"
        },
        "confirmation": {
          "delete_article": "Are you sure you want to delete \"{{article}}\" article?"
        }
      },
      "details_panel": {
        "title": "Title ({{lang}})",
        "short_content": "Short Content ({{lang}})",
        "content": "Content ({{lang}})",
        "created_at": "Created At",
        "updated_at": "Updated At",
        "subjects": "Subjects"
      },
      "article_form": {
        "edit_title": "Edit Article",
        "create_title": "Create Article",
        "editor_title": "Text Editor",
        "submit": "Submit",
        "cancel": "Cancel",
        "save": "Save",
        "form": {
          "subjects": "Subjects",
          "title": "Title ({{lang}})",
          "short_content": "Short content ({{lang}})",
          "content": "Content ({{lang}})",
          "errors": {
            "subject": {
              "required": "Subjects is required"
            }
          }
        }
      }
    }
  }
}
